import React, { useState } from "react";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import api from "../../Axios";
import Swal from "sweetalert2";

const AddProfile = () => {
  const history = useHistory();

  const [data, setData] = useState({
    referedMe: "Admin",
    profileCreatedFor: "",
    userName: "",
    gender: "male",
    dobDay: "",
    dobMonth: "",
    dobYear: "",
    religion: "",
    kulam: "",
    phone: "",
    email: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const kulamList = [
    "Beerahavaru",
    "Bodhuvaru",
    "Bomma jallivaru",
    "Boothivaru",
    "Dhasarivaru",
    "Dheiyaluvaru",
    "Dhogaluvaru",
    "Dhommaluvaru",
    "Dhoothaluvaruu",
    "Eeraluvaru",
    "Engiti aaguluvaru",
    "Entaluvaru",
    "Entavaru",
    "Eramavaru",
    "Etthulu Thantavaru",
    "Janavaru",
    "Jallivaru",
    "Jitthaluvaru",
    "Kachchavaru",
    "Kannadivaru",
    "Karavaru",
    "Kejjaluvaru",
    "Kodavaru",
    "Kommuvaru",
    "Kommuluvaru",
    "Kobaluvaru",
    "Koolivaru",
    "Kothaluvaru",
    "Kotangivaru",
    "Kuntamukkavaru",
    "Kuntavaru",
    "Kurukunjaluvaru",
    "Machchaluvaru",
    "Maithulavaru",
    "Mangavaru",
    "Mamidikuntaluvaru",
    "Mudikiluvaru",
    "Nallamullavaru",
    "Nelliyamvaru",
    "Other",
    "Pachchiluvaru",
    "Pallavaru",
    "Pandhivaru",
    "Pantivaru",
    "Paravaru",
    "Parvaivaru",
    "Patamasalavaru",
    "Payidikutthaluvaru",
    "Peguluvaru",
    "Pittavaru",
    "Pannavaru",
    "Puliputthaluvaru",
    "Rama jallivaru",
    "Santhavaru",
    "Sembootthuluvaru",
    "Settiselvaru",
    "Soothaluvaru",
    "Sullivaru",
    "Sutravaru",
    "Vejivaru"
  ];


  const inputStyle = {
    border: "1.5px solid #757575",
    borderRadius: "12px",
    boxShadow: "none",
    outline: "none",
    fontWeight: "bold",
    color: "#333",
  };

  const labelStyle = {
    color: "#212121",
    fontWeight: "800",
    marginBottom: "6px",
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Convert Month name to number
    const monthIndex =
      [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ].indexOf(data.dobMonth) + 1;

    const finalDob = `${data.dobDay.padStart(2, "0")}-${String(
      monthIndex
    ).padStart(2, "0")}-${data.dobYear}`;

    const payload = {
      referedMe: data.referedMe,
      profileCreatedFor: data.profileCreatedFor,
      userName: data.userName,
      gender: data.gender,
      dob: finalDob,
      religion: data.religion,
      kulam: data.kulam,
      phone: data.phone,
      email: data.email,
    };

    api
      .post("/admin/userProfile/addUser/", payload)
      .then((res) => {
        setData("");
        Swal.fire("Success", "Profile details submitted", "success");
        history.push(`/addpersonality/${res.data.data.id}`);
      })
      .catch((error) => {
        Swal.fire("Error", error.message || "Something went wrong", { error });
      });

    e.currentTarget.reset();
  };

  return (
    <div style={{ background: "#fff", marginTop: "70px" }}>
      <div
        style={{
          color: "#1a237e",
          fontWeight: "900",
          padding: "20px 10px",
        }}
      >
        <h4 style={{ fontSize: "1.8rem" }}>Profile Registration</h4>
      </div>

      <Form
        onSubmit={handleSubmit}
        style={{ padding: 24, maxWidth: 1200, margin: "0 10px" }}
      >
        <FormGroup>
          <Label style={labelStyle}>Profile Created for</Label>
          <Input
            type="select"
            name="profileCreatedFor"
            value={data.profileCreatedFor}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Profile created for</option>
            <option value="myself">Myself</option>
            <option value="son">Son</option>
            <option value="daughter">Daughter</option>
            <option value="brother">Brother</option>
            <option value="sister">Sister</option>
            {/* <option value="relative">Relative</option>
            <option value="friend">Friend</option> */}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Name</Label>
          <Input
            type="text"
            name="userName"
            placeholder="Enter your name"
            value={data.userName}
            onChange={handleChange}
            style={inputStyle}
          />
        </FormGroup>

        <Label style={labelStyle}>What is your gender</Label>
        <div className="d-flex mb-3">
          <Button
            type="button"
            onClick={() => setData({ ...data, gender: "male" })}
            style={{
              background: data.gender === "male" ? "green" : "#eee",
              color: data.gender === "male" ? "#fff" : "#292929",
              borderRadius: 10,
              border: "1px solid #7b7b7b",
              marginRight: 10,
              width: "150px",
            }}
          >
            Male
          </Button>
          <Button
            type="button"
            onClick={() => setData({ ...data, gender: "female" })}
            style={{
              background: data.gender === "female" ? "green" : "#eee",
              color: data.gender === "female" ? "#fff" : "#292929",
              borderRadius: 10,
              border: "1px solid #7b7b7b",
              width: "150px",
            }}
          >
            Female
          </Button>
        </div>

        <FormGroup>
          <Label style={labelStyle}>Date of Birth</Label>
          <Row>
            <Col xs="4">
              <Input
                type="select"
                name="dobDay"
                value={data.dobDay}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="">Day</option>
                {[...Array(31)].map((_, i) => (
                  <option key={i + 1} value={String(i + 1).padStart(2, "0")}>
                    {i + 1}
                  </option>
                ))}
              </Input>
            </Col>
            <Col xs="4">
              <Input
                type="select"
                name="dobMonth"
                value={data.dobMonth}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="">Month</option>
                {[
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </Input>
            </Col>
            <Col xs="4">
              <Input
                type="select"
                name="dobYear"
                value={data.dobYear}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="">Year</option>
                {Array.from(
                  { length: 50 },
                  (_, i) => new Date().getFullYear() - i
                ).map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </Input>
            </Col>
          </Row>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Religion</Label>
          <Input
            type="select"
            name="religion"
            value={data.religion}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select your religion</option>
            <option value="hindu">Hindu</option>
            {/* <option value="muslim">Muslim</option>
            <option value="christian">Christian</option>
            <option value="other">Other</option> */}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Kulam</Label>
          <Input
            type="select"
            name="kulam"
            value={data.kulam}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select your Kulam</option>
            {kulamList.map((kulam, index) => (
              <option key={index} value={kulam}>
                {kulam}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Mobile Number</Label>
          <Input
            type="text"
            name="phone"
            placeholder="Enter your Mobile No"
            value={data.phone}
            onChange={(e) => {
              const value = e.target.value;

              if (/^\d*$/.test(value) && value.length <= 10) {
                handleChange(e);
              }
            }}
            style={inputStyle}
          />
        </FormGroup>


        <FormGroup>
          <Label style={labelStyle}>Email ID</Label>
          <Input
            type="email"
            name="email"
            placeholder="Enter your Email ID"
            value={data.email}
            onChange={handleChange}
            style={inputStyle}
          />
        </FormGroup>

        <Button
          type="submit"
          style={{
            width: "30%",
            borderRadius: 8,
            backgroundColor: "#000",
            color: "#fff",
            fontWeight: "bold",
            padding: "10px 0",
          }}
          block
        >
          Save & Continue
        </Button>
      </Form>
    </div>
  );
};

export default AddProfile;
